export default __webpack_public_path__ + "static/media/gym.b41f73a7.svg";